<template>
	<div>
	<v-navigation-drawer app id="sidebar" v-model="drawer" color="white" height="100%" class="elevation-4">
		<template v-slot:prepend>
			<div class="mb-3" v-if="auth.logged_in">
				<UserInfo></UserInfo>
			</div>
			<div v-else class="mb-3">
				<!-- <Register @forgotPassword="trigger_forgot_password = true"></Register> -->
				<Login @forgotPassword="trigger_forgot_password = true"></Login>
			</div>
		</template>
		<template v-slot:append>		

			<div  class="mb-1" v-if="auth.logged_in">
				<MeetingRoomButton></MeetingRoomButton>
				<NavigationItem 
					name="Teams" 
					icon="mdi-account-group" 
					iconcolor="grey"
					description="Kollaborationsmodule für alle Erhebungsverantwortlichen"
					type="link"
					to="teams"
					>					
					<template v-slot:childContent>
					</template>
				</NavigationItem>
				<NavigationGroup 
					name="Support" 
					icon="mdi-help-circle" 
					iconcolor="grey"
					description="Unterstützungsmodule für Ihre Erhebung"
					type="collapse"
					:children="[
						{name: 'FAQ',  icon: 'mdi-comment-question', description: 'Frequently asked Questions' },
						{name: 'Anleitung', icon: 'mdi-information', description: 'Informationen zur Nutzung' },
						{name: 'Kontakt', icon: 'mdi-pencil-circle', description: 'Kontaktieren Sie unser Team' }
					]"
					>					
					<template v-slot:childContent>
						<LiveChatButton @click="show_chat = true; chat_started = true;"></LiveChatButton>
					</template>
				</NavigationGroup>
			</div>
			<div v-else class="mb-3"> 
				<ForgotPassword :trigger="trigger_forgot_password" @close="trigger_forgot_password = false"></ForgotPassword>
			</div>
		</template>
		<v-divider></v-divider>		
		<Navigation></Navigation>
	</v-navigation-drawer>
	<LiveChat v-if="chat_started" :show="show_chat" @open="show_chat = true" @close="show_chat = false"></LiveChat>
</div>
</template>
<style lang="less">
.v-list-item__subtitle.font-weight-light{
	font-size: 0.65em !important;
	line-height: 1.3em !important;
	overflow: auto;
	overflow-x: hidden;
	white-space: break-spaces !important;
}


</style>

<script>
// import Register from "@/components/forms/Register"
import Login from "@/components/forms/Login"
import ForgotPassword from "@/components/forms/ForgotPassword"
import UserInfo from "@/components/info/UserInfo"
import Navigation from "@/components/content/Navigation"
import LiveChatButton from "@/components/assessment/communication/LiveChatButton"
import MeetingRoomButton from "@/components/assessment/communication/MeetingRoomButton"
import LiveChat from "@/components/assessment/communication/LiveChat"
import Vuex from "vuex"
import NavigationGroup from "@/components/elements/NavigationGroup"
import NavigationItem from "@/components/elements/NavigationItem"

export default {
	name: 'SideBar',
	props: {
		"trigger": {type: Boolean }
	},
	components: {
		ForgotPassword,
		LiveChat,
		LiveChatButton,
		Login,
		MeetingRoomButton,
		Navigation,	
		NavigationGroup,
		NavigationItem,
		// Register,
		UserInfo,
		// ScoreAvatar
	},
	computed: {
		...Vuex.mapState( {
			auth: state => state.auth,
			user: state => state.user, 
			view: state => state.view, 
		} ),
	},
	data: () => ({
		drawer: true,
		trigger_forgot_password: false,
		show_chat: false, 
		chat_started: false
	}),
	methods: {
			
	},
	watch:  {
		trigger: {
			immediate: true,
			handler(){
				this.drawer = this.trigger	
			}
		},
		drawer: {
			handler() {
				this.$emit("change", this.drawer)
			}
		}
	}
};
</script>
